import { render, staticRenderFns } from "./ResearcherRemarks.vue?vue&type=template&id=09fd8a2a&"
import script from "./ResearcherRemarks.vue?vue&type=script&lang=js&"
export * from "./ResearcherRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports